import React from 'react';
import {OrganizerDto} from '../../generated/models/OrganizerDto';
import {PendingClaimPlaceRow} from './PendingClaimPlaceRow';

type OrganizerClaimGroupProps = React.FC<{
  organizer: OrganizerDto;
  onApprove: (placeId: string, organizerId: string) => void;
  onDecline: (placeId: string, organizerId: string) => void;
}>;

export const OrganizerClaimGroup: OrganizerClaimGroupProps = ({
  organizer,
  onApprove,
  onDecline,
}) => {
  const places = organizer.places ?? [];

  return (
    <div
      style={{
        backgroundColor: '#222',
        padding: '25px',
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
      }}>
      <h3 style={{color: '#fff', margin: 0, fontSize: '1.4rem'}}>
        {organizer.name}
      </h3>
      <p style={{color: '#aaa', margin: '4px 0 0', fontSize: '1rem'}}>
        {organizer.companyName || ''}
      </p>

      <div style={{height: 1, backgroundColor: '#333', margin: '16px 0 4px'}} />

      {places.length > 0 ? (
        places.map((place, idx) => (
          <PendingClaimPlaceRow
            key={place.placeId ?? idx}
            place={place}
            onApprove={() => onApprove(place.placeId ?? '', organizer.id)}
            onDecline={() => onDecline(place.placeId ?? '', organizer.id)}
          />
        ))
      ) : (
        <p style={{color: '#666', margin: 0}}>No places for this organizer.</p>
      )}
    </div>
  );
};
